import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {Train} from '../models/train';
import {PeriodData} from '../models/periodData';
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class TrainDataService {

  constructor(private http: HttpClient) { }

  getTrainslist = (projectId: number): Observable<Train[]> => {
    return this.http.get<any[]>(`${environment.api.baseUrl}/${environment.api.endpoints.train.trainList}/${projectId}`).pipe(
        map((trains: any[]) => trains.sort((x,y) => x.name < y.name ? -1 : 1).map( train => {
          train.trainType = train.type;
          return train;
        }))
    );
  }

  getTrain = (trainId: number, projectId: number): Promise<Train> => {
    return this.http.get<Train>(`${environment.api.baseUrl}/${environment.api.endpoints.train.train}/${trainId}?projectId=${projectId}`).toPromise();
  }

  updateTrain = (train: Train, trainUpdate: boolean) => {

    const trainObj = {
      ...train,
      type: train.trainType
    };
    delete  trainObj.trainType;

    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.train.trainConfig}/new?update=${trainUpdate}`, trainObj).toPromise();
  }

  deleteTrain = (trainRelativeId: number, projectId: number) => {
    return this.http.delete(`${environment.api.baseUrl}/${environment.api.endpoints.train.trainConfig}/${trainRelativeId}?projectId=${projectId}`).toPromise();
  }

  getPeriodData = (utcStart: string, utcEnd: string, projectId: number, trainId: number) => {
    const params = new HttpParams()
        .set('projectId', projectId.toString())
        .set('relativeId', trainId.toString())
        .set('from', utcStart)
        .set('to', utcEnd);

    return this.http.get<PeriodData>(`${environment.api.baseUrl}/${environment.api.endpoints.train.train}/period`, {params}).toPromise();
  }

}
